(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-tabs"] && !Shopify.designMode) return;
  try {
    
  class GalleryTabsComponent extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.#activate(index));
        tab.addEventListener('keydown', (event) => this.#onKeydown(event, index));
      });

      this.onBlockSelect = (event) => {
        if (!this.contains(event.target)) return;

        const index = this.tabs.findIndex((tab) => tab.getAttribute('aria-controls') === event.target.id);
        if (index !== -1) this.#activate(index, false);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    #panelFor(tab) {
      const id = tab.getAttribute('aria-controls');
      return id ? this.querySelector(`#${CSS.escape(id)}`) : null;
    }

    #activate(index, moveFocus = true) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;

        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;

        const panel = this.#panelFor(tab);
        if (!panel) return;

        panel.classList.toggle('gallery-tab--active', selected);
        panel.toggleAttribute('inert', !selected);
      });

      if (moveFocus) this.tabs[index]?.focus();
    }

    #onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;

      switch (event.key) {
        case 'ArrowRight':
          next = index === last ? 0 : index + 1;
          break;
        case 'ArrowLeft':
          next = index === 0 ? last : index - 1;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = last;
          break;
      }

      if (next === null) return;

      event.preventDefault();
      this.#activate(next);
    }
  }

  if (!customElements.get('gallery-tabs-component')) {
    customElements.define('gallery-tabs-component', GalleryTabsComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
